import type {Falsy} from 'quickstart/types'
import {markdown} from 'quickstart/utils/markdown'
import {useMemo} from 'react'
import {useHack} from './useHack'

export function useMarkdown(source: string | Falsy): string | null {
  const br = useHack('br')
  return useMemo(() => (source ? markdown(source, {br}) : null), [br, source])
}
